import React from 'react';
import Grid from '@mui/material/Grid2';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import BreadCrumbs from "../../../components/elements/BreadCrumbs";
import AppAnimate from "../../../components/AppAnimate";
import AppCard from "../../../components/layout/components/AppCard";
import AddUser from "./AddUser";
import MakeUser from "./MakeUser";
import {useTranslation} from "react-i18next";
import Title from "../../../components/elements/Title";


function OrganizationsPage({edit}){
    const { t } = useTranslation();

    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={!!edit ? t('editUser') : t('addUser')}>
            <Grid container spacing={2} justifyContent="center">
                <Grid item size={{xs:12,md:10,lg:8}} >
                    <Title align="left" color="text">{!!edit ? t('editUser') : t('addUser')}</Title>
                    {
                        !!edit ?
                            <MakeUser/>
                            :
                            <AddUser/>

                    }
                </Grid>
            </Grid>
        </AppAnimate>
    );
}
export default withStyles(Styles)(OrganizationsPage);
